<ion-row>
  <ion-col>
    <ion-row *ngIf="valgtMaanedAnlegg" class="nokkeltall-grid">
      <ion-col size="12">
        <ion-row class="row-m">
          <ion-col class="box-col-nokkeltall">
            <p>Forbruk</p>
            <p class="nokkeltall">{{ toRoundNumber(forbrukThisYear) }} kWh</p>
            <p *ngIf="isPlusskunde">netto etter prod.</p>
          </ion-col>
          <ion-col class="box-col-nokkeltall">
            <p>Estimert kostnad</p>
            <p class="nokkeltall">{{ toRoundNumber(kostnadThisYear) }} kr</p>
            <p *ngIf="isPlusskunde">netto etter inntekt</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            class="box-col-nokkeltall flex flex-row justify-around"
            *ngIf="isPlusskunde"
          >
            <div class="flex flex-col">
              <p>Produksjon</p>
              <div class="flex-end">
                <p class="nokkeltall">{{ toRoundNumber(produksjon) }} kWh</p>
              </div>
            </div>
            <div class="flex flex-col">
              <p>Inntekter</p>
              <div class="flex-end">
                <p class="nokkeltall">{{ toRoundNumber(inntekt) }} kr</p>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
